import React, { Component } from "react";
import { ScrollView, Text, View, TouchableOpacity } from "react-native";
import { button, Colors, FontFamily } from "../../styles/appStyles";
import apiHelpers from "../../utils/api-helpers";
import { helpers } from "../../utils/helpers";
import getImagePath from "../../utils/image-helper";
import ButtonGradient from "../button-gradient";
import CustomImage from "../custom-image";
import _ from "lodash";
import Button from "../button";
import moment from "moment";

const checkWhiteIcon = getImagePath("icons/checkWhite.png");
const checkIcon = getImagePath("icons/check.png");
const groupelipse = getImagePath("icons/groupelipse.png");
const groupelipsetick = getImagePath("icons/groupelipsetick.png");

class SubscriptionApiCall extends Component {
  constructor(props) {
    super(props);

    this.state = {
      plans: [],
      features: [],
      selectedPlan: [],
      currentPlan: [],
      isPlanChanged: false,
      planList: [],
    };

    this.selectPlanData = this.selectPlanData.bind(this);
  }
  componentDidMount() {

    let endpoint = `/plans/${this.props.planType}/${this.props.country?.code}`;
    let data;
    console.log('mob view', this.props.data);

    let selectedPlan =
      this.props.data.length &&
      this.props.data.filter(
        (d, i) => d.id === this.props.userSubscription?.plan?.id
      );
    let freePlan =
      this.props.data.length &&
      this.props.data.filter((d, i) => d.tmc_group === "free");

    this.setState({
      selectedPlan: selectedPlan.length > 0 ? selectedPlan : freePlan,
      currentPlan: selectedPlan.length > 0 ? selectedPlan : freePlan,
    });

    apiHelpers
      .apiRequest(endpoint, {}, "POST", true, this.props.token)
      .then((res) => {
        let plansData = Object.keys(res.plans).map((item) => {
          return {
            id: item,
            plan_name: res.plans[item].plan_name,
          }
        });

        for (var j = 0; j < plansData.length; j++) {
          for (var i = 0; i < this.props.data.length; i++) {
            if (plansData[j].id == this.props.data[i].id || plansData[j].plan_name == this.props.data[i].name) {
              plansData[j].price = this.props.data[i].price;
              plansData[j].plan_name = plansData[j].plan_name.replace(" Plan", "");
              break;
            }
          }
        }

        console.log('mob view', plansData);


        let planList = plansData.filter(
          (d, i) => d.price >= this.state.currentPlan[0].price
        );

        this.setState({
          features: Object.values(res.features),
          plans: plansData,
          planList: planList,
        });
      })

      // let data = this.state.features.json()
      .catch((error) => {
        console.log("Error=>>", error);
      });
  }

  /**
   * Select plan for subscription
   */
  selectPlanData = (params) => {
    let _dd = [];
    if (params.plan_name !== "Free") {
      _dd = this.props.data.filter((d, i) => d.id === params.id);
    } else {
      _dd = this.props.data.filter((d, i) => d.tmc_group === "free");
    }
    this.setState({
      selectedPlan: _dd,
      isPlanChanged:
        params.id !== this.state.currentPlan[0].id
          ? true
          : false,
    }, () => {
      console.log('mob view:', this.state.isPlanChanged);
    });
  };

  cancelPlan = () => {
    this.props.navigateScreen("accounts/cancel-subscription", {
      plan:
        this.props.userSubscription &&
          this.props.userSubscription.is_cancelled == false
          ? true
          : false,
    });
  };

  /**
   * Generate Button Title
   */
  createButtonName = () => {
    let { darkMode, userSubscription, token, country, auth, subscribeToPlan } =
      this.props;
    let {
      features,
      plans,
      selectedPlan,
      isPlanChanged,
      currentPlan,
      planList,
    } = this.state;
    if (
      currentPlan[0]?.name?.replace(" Plan", "") ===
      selectedPlan[0]?.name?.replace(" Plan", "")
    )
      return "YOUR CURRENT PLAN";
    else if (!userSubscription) {
      return "SUBSCRIBE";
    } else return "UPGRADE PLAN";
  };

  goToSignUp = (email) => {
    if (helpers.isWeb()) {
      this.props.navigateToScreen(
        "/sign-up?redirect=/pricing" + (email ? "&email=" + email : "")
      );
    } else {
      this.props.navigateScreen("/sign-up", {
        redirect: "/pricing",
        verifyRedirect: "/pricing",
        email: email,
      });
    }
  };
  render() {
    let { darkMode, userSubscription, token, country, auth, subscribeToPlan, sidePanel } =
      this.props;

    let checkDesktop = sidePanel ? false : !helpers.isDesktop() ? true : false;

    let {
      features,
      plans,
      selectedPlan,
      isPlanChanged,
      currentPlan,
      planList,
    } = this.state;
    let isUserLoggedIn = auth.isAuthenticated;
    let btnClick;
    if (helpers.isWeb()) {
      btnClick = {
        to: "/pricing",
      };
    } else {
      btnClick = {
        onPress: () => this.props.navigateScreen("/pricing"),
      };
    }

    return features && planList?.length > 0 ? (
      <View
        style={[
          {
            width: "100%",
            justifyContent: "center",
            alignItems: "center",
            // marginTop: -60,
          },
          !darkMode && { backgroundColor: "#fff" },
          darkMode && { backgroundColor: "black" },
        ]}
      >
        <View
          style={{
            // borderWidth:5,
            width: "100%",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Text
            style={{
              fontFamily: FontFamily.abrilFatface,
              fontSize: 32,
              textAlign: "center",
              color: darkMode ? "white" : "#051462",
              marginVertical: helpers.isDesktop() ? 0 : 18,
            }}
          >
            Choose Your Subscription
          </Text>
        </View>
        <View style={{ width: "94%", flexDirection: "row", marginLeft: 0 }}>
          <View style={{ width: "25%" }}>
            <View style={{ padding: 10, height: 90 }}></View>

            {features.map((item, index) => {
              return (
                <View
                  style={{
                    height: 92,
                    marginVertical: 3,
                    justifyContent: "center",
                  }}
                >
                  <Text
                    style={{
                      fontFamily: FontFamily.regular,
                      fontSize: 14,
                      lineHeight: 17,
                      color: darkMode ? "white" : "#051462",
                      marginBottom: 4,
                      marginTop: 2,
                    }}
                  >
                    {item.display_name}
                  </Text>
                </View>
              );
            })}
          </View>

          <ScrollView
            horizontal={true}
            showsHorizontalScrollIndicator={false}
            contentContainerStyle={{
              marginEnd: 100,
              width: "100%",
            }}
          >
            <View style={{ width: "100%" }}>
              <View
                style={{
                  width: "100%",
                  flexDirection: "row",
                  display: "flex",
                  marginTop: "14%",
                  // height: 92,
                  // marginVertical: 3,
                  // justifyContent: "center",
                }}
              >
                {planList.map((item, index) => {
                  return (
                    <View
                      style={{
                        // width: 100 / planList.length + "%",
                        width: 80,
                        //   justifyContent: "center",
                        alignItems: "center",
                        //   padding: 10,
                        flexDirection: "column",
                        // marginLeft: 10, marginRight: 10
                        //   height: 90,
                      }}
                    >
                      {isUserLoggedIn ? (
                        <TouchableOpacity
                          onPress={() => this.selectPlanData(item)}
                        >
                          <CustomImage
                            source={
                              selectedPlan[0]?.id === item.id ||
                                selectedPlan[0]?.name?.replace(" Plan", "") ===
                                item.plan_name
                                ? groupelipsetick
                                : groupelipse
                            }
                            require={true}
                            style={{
                              width: 20,
                              height: 20,
                              resizeMode: "contain",
                              marginTop: 3,
                              marginBottom: 10,
                            }}
                            webStyle={{
                              width: 20,
                              height: 20,
                              objectFit: "contain",
                              marginBottom: 10,
                              // marginTop: !userSubscription && !token ? 20 : 58,
                            }}
                          />
                        </TouchableOpacity>
                      ) : null}
                      <>
                        <Text
                          style={{
                            fontFamily: FontFamily.medium,
                            textAlign: "center",
                            color: darkMode ? "white" : "#051462",
                            textTransform: "uppercase",
                          }}
                        >
                          {item.plan_name}
                        </Text>
                        {item.plan_name == "Free"
                          ? !userSubscription &&
                          !isUserLoggedIn && (
                            <Text
                              style={{
                                fontFamily: FontFamily.medium,
                                textAlign: "center",
                                color: "#FC876D",
                                fontSize: 8,
                                textTransform: "uppercase",
                              }}
                            >
                              CREDIT CARD {"\n"} NOT REQUIRED
                            </Text>
                          )
                          : null}
                        {currentPlan[0].name.replace(" Plan", "") ===
                          item.plan_name &&
                          isUserLoggedIn && (
                            <Text
                              style={{
                                fontFamily: FontFamily.medium,
                                textAlign: "center",
                                color: "#907CFF",
                                fontSize: 8,
                                textTransform: "uppercase",
                              }}
                            >
                              Current Plan
                            </Text>
                          )}
                      </>
                    </View>
                  );
                })}
              </View>

              {features.map((item, index) => {
                // convert object to string as resposne has '-' in it
                let val = JSON.stringify(item?.plans_map);
                // convert back string to object
                let newVal = JSON.parse(val);

                return (
                  <>
                    <View
                      style={[
                        {
                          width: "100%",
                          flexDirection: "row",
                          display: "flex",
                          alignItems: "center",
                        },
                      ]}
                    >
                      {planList.map((plan) => {
                        return (
                          <View
                            style={{
                              height: 92,
                              // width: 100 / planList.length + "%",
                              width: 80,
                              justifyContent: "center",
                              alignItems: "center",
                              marginVertical: 3,
                            }}
                          >
                            {newVal[plan.id] ? (
                              newVal[plan.id] == "Limited" ? (
                                <Text
                                  style={{
                                    fontFamily: FontFamily.Matteo,
                                    textAlign: "center",
                                    color: darkMode ? "white" : "#051462",
                                    fontSize: 10,
                                    // fontWeight: 400,
                                    // lineHeight: 17,
                                    letterSpacing: 0.03,
                                    marginTop: !userSubscription
                                      ? isUserLoggedIn
                                        ? "-10px"
                                        : "40px"
                                      : "0px",
                                  }}
                                >
                                  Limited
                                </Text>
                              ) : (
                                <CustomImage
                                  source={checkIcon}
                                  require={true}
                                  style={{
                                    width: 20,
                                    height: 14,
                                    resizeMode: "contain",
                                    marginTop: 3,
                                  }}
                                  webStyle={{
                                    width: 20,
                                    height: 14,
                                    objectFit: "contain",
                                    marginTop: !userSubscription
                                      ? isUserLoggedIn
                                        ? "-10px"
                                        : "40px"
                                      : "0px",
                                  }}
                                />
                              )
                            ) : null}
                          </View>
                        );
                      })}
                    </View>
                  </>
                );
              })}
            </View>
          </ScrollView>
        </View>
        {this.props.showIosMessage && (
          <View
            style={[
              {
                backgroundColor: darkMode ? Colors.darkBlackColor1 : "#FFFAEB",
                paddingHorizontal: 25,
                paddingTop: 15,
                minHeight: 100,
                marginTop: 20,
              },
              // !userSubscription &&
              //   !teamSubscription && { marginBottom: 20 },
              // (userSubscription || teamSubscription) && {
              //   marginBottom: -15,
              // },
            ]}
          >
            <Text
              style={{
                fontSize: 16,
                lineHeight: 27,
                letterSpacing: 0.3,
                color: darkMode ? Colors.lightWhite : "#2D2D2D",
                fontFamily: FontFamily.merriweather,
                textAlign: "center",
              }}
            >
              You can’t upgrade in the app. We know it’s a hassle.
            </Text>
          </View>
        )}
        {!this.props.token && !isUserLoggedIn ? (
          <View style={{ marginTop: 120, marginBottom: 40, width: "75%" }}>
            <ButtonGradient
              title={"SIGN UP"}
              onClick={() => {
                this.props.navigateScreen("/sign-up?redirect=/");
              }}
              rootStyle={{
                btnWrapper: [
                  button.primaryGradientBtn,
                  {
                    height: 46,
                    borderRadius: 0,
                    flex: 1,
                    position: "relative",
                    right: helpers.isDesktop() ? 1.5 : 0,
                  },
                ],
                btnText: [
                  button.primaryGradientText,
                  {
                    fontSize: helpers.isDesktop() ? 17 : 16,
                    fontWeight: "600",
                    paddingLeft: 35,
                    paddingRight: 35,
                    paddingTop: helpers.isDesktop() ? 0 : 15,
                    paddingBottom: helpers.isDesktop() ? 0 : 15,
                  },
                ],
              }}
              loader={false}
              disable={false}
              darkMode={darkMode}
            />
          </View>
        ) : (
          <View style={{ marginTop: 40, marginBottom: 40, width: "75%" }}>
            {
              checkDesktop || (currentPlan[0]?.name?.replace(" Plan", "") !==
                selectedPlan[0]?.name?.replace(" Plan", "")) || !userSubscription ? (
                <Button
                  title={this.createButtonName()}
                  onClick={() => {
                    subscribeToPlan(selectedPlan[0]);
                  }}
                  disable={!isPlanChanged}
                  rootStyle={{
                    btnWrapper: [
                      button.primaryGradient,
                      {
                        backgroundColor: "#ffffff",
                        borderWidth: 1,
                        borderColor: "#907CFF",
                      },
                    ],
                    btnText: [
                      button.primaryGradientText,
                      button.primaryGradientTextViewlogout,
                      { fontWeight: "600", fontSize: 17 },
                    ],
                  }}
                  loader={false}
                  darkMode={darkMode}
                />
              ) : (
                userSubscription?.end_date && currentPlan[0]?.name?.replace(" Plan", "") ===
                  selectedPlan[0]?.name?.replace(" Plan", "") ? (
                  <View
                    style={{
                      lineHeight: 5,
                    }}
                  >
                    <Text
                      style={{
                        color: darkMode ? "#FFF" : "#000",
                        fontWeight: 500,
                        fontFamily: "Matteo-Medium",
                        textAlign: "center",
                      }}
                    >
                      Your current plan will expire on{" "}
                      {moment(userSubscription.end_date).format(
                        "Do MMMM YYYY"
                      )}
                    </Text>

                    <TouchableOpacity
                      style={{
                        lineHeight: 5,
                        paddingTop: 13,
                        paddingBottom: 13,
                        paddingLeft: 45,
                        paddingRight: 45,
                        textDecorationLine: "underline",
                        color: darkMode ? "#FFF" : "#000",
                        fontWeight: 500,
                        fontFamily: "Matteo-Medium",
                        cursor: "pointer",
                      }}
                      onPress={() => this.cancelPlan()}
                    >
                      <Text
                        style={{
                          color: darkMode ? "#FFF" : "#000",
                          fontWeight: 500,
                          fontFamily: "Matteo-Medium",
                          cursor: "pointer",
                          textAlign: "center",
                        }}
                      >
                        Cancel Subscription
                      </Text>
                    </TouchableOpacity>
                  </View>
                ) : null
              )
            }
          </View>
        )}
      </View>
    ) : null;
  }
}

export default SubscriptionApiCall;
